import { useForm } from 'react-hook-form'
import { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import '../styles/swicthcss.css'

import { projectContext, loadingContext, urlValue, unfolder, openAlert } from '../lib'
import SelectCodeModal from './SelectCodeModal'
import SwitchBtn from './common/SwitchBtn'
import ButtonYesNo from './common/ButtonYesNo'
import BoxInfo from './common/BoxInfo'
import { Alerts } from './common/Alerts'
import { InputNesting } from './common/Inputs/Input'
import PlayIcon from '../images/play-icon.svg'
import PauseIcon from '../images/pause-icon.svg'

export function SettingsOptions({ isModalOpen, closeModal, update }) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [users, setUsers] = useState([{}])
  const [loading, setLoading] = useContext(loadingContext)
  const [nlp_config, setNlp_config] = useState(null);
  const [bot_type, setBot_type] = useState(false);
  const [default_Sentiment, setDefault_Sentiment] = useState(false);
  const [nlp_configName, setNlp_configName] = useState("Upload");
  const [language, setLanguage] = useState("EN-US");
  const [campaings, setCampaings] = useState([])
  const [subCampaings, setSubCampaings] = useState([])
  const [alert, setAlert] = useState({ title: '', visible: false })
  const campaingRef = useRef()
  const subCampaingRef = useRef()
  const [hold, setHold] = useState(0)
  const timeHoldRef = useRef();
  const timeHoldAmountRef = useRef();
  const sentimentBotRef = useRef();
  const useDefaultSentimentRef = useRef();
  const [radomVoice, setRadomVoice] = useState(false)
  const [voices, setVoices] = useState([])
  const [error, setError] = useState({ name: "" })
  const url_simulationRef = useRef();
  const affectation_time_ref = useRef();
  const percentage_affectation_ref = useRef();
  const [category, setCategory] = useState('outbound');
  const [transcription, setTranscription] = useState(0);
  const [useDefaultSentiment, setUseDefaultSentiment] = useState(0);
  const [timeHold, setTimeHold] = useState(0);
  const [amountTimeHold, setAmountTimeHold] = useState(0);
  const [modelSentiment, setModelSentiment] = useState('Voice');
  const [channel, setChannel] = useState("voice")
  const [assistedSimulation, setAssistedSimulation] = useState(null);
  const [simulationStatus, setSimulationStatus] = useState(null);

  const minimunCallDurations = useRef();
  const maxUserResponseTime = useRef();
  const bot_respose_time_ref = useRef();
  const Simulation_Step_number_ref = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const roles = {
    1: 'Admin',
    2: 'Manager',
    3: 'Editor',
    4: 'Reader',
  }


  const getUsers = async () => {

    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token


      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/user/users-project/${selectedProject.id}`,
        headers: {
          'access-token': token,
        },
      })

      setUsers(response.data)

      return response;
    } catch (error) {
      console.log(error)

      return error
    }

  }

  useEffect(() => {
    (async () => { await getUsers(); })()

  }, [])

  useEffect(() => {
    (async () => {

      await fetchVoice();
      await fetchCampaing();
      await fetchSubCampaing();
      await getProject();

    })()



  }, []);

  const ChangeModelSentiment = (e) => {
    if (e.target.value === 'Voice') {
      selectedProject.bot_sentiment = 0;
    }
  }

  const saveBotSentimentConfig = function (e) {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

    axios({
      method: 'post',
      url: `${urlValue}/studio/project/${selectedProject.id}/bot_sentiment`,
      headers: {
        user: id,
        'access-token': token,
      },
      data: {
        bot_sentiment: e.target.value,
      }
    }).then(function (res) {
      // console.log('res', res);
    }).catch(error => {
      console.log('Error to try update bot sentiment: ', error);
    })
  }

  const saveProject = (e) => {
    e.preventDefault();
    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    const name = selectedProject.name;

    const exp = /^[A-Za-z0-9-,._'\s]+$/g;
    if (!exp.test(name)) {
      ok = false;

      setError({ ...error, name: "The name cannot contain symbols and special characters." })
    }
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    if (ok) {
      const voice = document.querySelector("#voice").value;
      const dataSend = {
        id: selectedProject.id,
        name: name,
        //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
        nlp: selectedProject.nlp,
        nlp_url: selectedProject.nlp_url,
        metadata: { "description": selectedProject.metadata.description, "language": language },
        //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
        image: selectedProject.image,
        hold: hold,
        time_hold_amount: timeHoldAmountRef.current?.value || 0,
        time_hold_seconds: timeHoldRef.current?.value || 0,
        use_hold: hold ? 1 : 0,
        url_tp_simulation: url_simulationRef.current?.value,
        simulation_status: simulationStatus,
        campaing: campaingRef.current?.value,
        sub_campaing: subCampaingRef.current?.value,
        channel: channel,
        voice: voice,
        random_voice: radomVoice ? 1 : 0,
        use_default_sentiment: useDefaultSentiment,
        bot_sentiment: sentimentBotRef.current?.value,
        model_sentiment: document.getElementById('model_sentiment').value,
        category: category,
        outbound_call: category === 'outbound' ? 1 : 0,
        transcription: transcription,
        welcome_msg: selectedProject.welcome_msg,
        affectation_time: parseInt(document.getElementById('affectation_time')?.value || 0),
        percentage_affectation: parseFloat(document.getElementById('percentage_affectation')?.value || 0),
        min_call_time: minimunCallDurations.current?.value || 0,
        max_user_response_time: maxUserResponseTime.current?.value || 0,
        bot_response_time: bot_respose_time_ref.current?.value || 1,
        num_simulation_steps: Simulation_Step_number_ref.current?.value || 1,
        assisted_simulation: assistedSimulation,
      }
      axios({
        method: 'put',
        url: `${urlValue}/studio/project`,
        headers: {
          user: id,
          'access-token': token,
        },
        data: dataSend,
      })
        .then(function (response) {
          setSelectedProject({
            ...selectedProject,
            name: name,
            voice_id: voice,
            campaing: campaingRef.current?.value,
            sub_campaing: subCampaingRef.current?.value,
            time_hold_amount: timeHoldAmountRef.current?.value || 0,
            time_hold_seconds: timeHoldRef.current?.value || 0,
            use_hold: hold ? 1 : 0,
            url_tp_simulation: url_simulationRef.current?.value,
            simulation_status: simulationStatus,
            random_voice: radomVoice ? 1 : 0,
            use_default_sentiment: useDefaultSentiment,
            bot_sentiment: sentimentBotRef.current?.value,
            model_sentiment: document.getElementById('model_sentiment').value,
            category: category,
            outbound_call: category === 'outbound' ? 1 : 0,
            transcription: transcription,
            affectation_time: document.getElementById('affectation_time')?.value || 0,
            percentage_affectation: document.getElementById('percentage_affectation')?.value || 0,
            min_call_time: minimunCallDurations.current?.value || 0,
            max_user_response_time: maxUserResponseTime.current?.value || 0,
            bot_respose_time: bot_respose_time_ref.current?.value || 1,
            num_simulation_steps: Simulation_Step_number_ref.current?.value || 1,
            assisted_simulation: assistedSimulation,
          })
          getProject();
          openAlert('#alert-ac', () => { setAlert({ title: 'Settings have been change properly!', visible: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
          setLoading(false)
        })
        .catch(function (error) {
          openAlert('#alert-ac', () => {setAlert({title: 'Settings could not save!!', visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
          console.error("error ", error)
        })
    }
  }

  const getProject = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    setLoading(true)
    try {
      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/project/${selectedProject.id}`,
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      })

      setSelectedProject(response.data)
      setLanguage(response.data.metadata.language);
      setTimeHold(response.data.TimeSecondHold);
      setAmountTimeHold(response.data.AmountTimeHold);
      setRadomVoice(response.data.random_voice);
      setHold(response.data.useHold);
      setUseDefaultSentiment(response.data.use_default_sentiment)
      setTranscription(response.data.transcription)
      setCategory(response.data.category)
      setChannel(response.data.channel)

      document.getElementById('url_tp_simulation').value = response.data.url_tp_simulation;
      document.getElementById('bot_sentiment').value = response.data.bot_sentiment;

      setCategory(selectedProject.category)
      setTranscription(selectedProject.transcription)
      setUseDefaultSentiment(selectedProject.use_default_sentiment)
      setTimeHold(selectedProject.TimeSecondHold)
      setAmountTimeHold(selectedProject.AmountTimeHold)
      setModelSentiment(selectedProject.model_sentiment)
      setChannel(selectedProject.channel)

      setAssistedSimulation(selectedProject.assisted_simulation)
      setSimulationStatus(selectedProject?.simulation_status)

      document.getElementById('model_sentiment').value = response.data.model_sentiment;
      document.getElementById('voice').value = response.data.voice_id;
      document.getElementById('campaign').value = response.data.campaing_id;
      document.getElementById('subcampaign').value = response.data.sub_campaing_id;

      document.getElementById('affectation_time').value = response.data.affectation_time;
      document.getElementById('percentage_affectation').value = response.data.percentage_affectation;
      document.getElementById('hold_time').value = response.data.TimeSecondHold;
      document.getElementById('amount_time_hold').value = response.data.AmountTimeHold;
      minimunCallDurations.current.value = response.data.min_call_time || 0;
      maxUserResponseTime.current.value = response.data.max_user_response_time || 0;
      bot_respose_time_ref.current.value = response.data.bot_response_time;
      Simulation_Step_number_ref.current.value = response.data.num_simulation_steps;
      setLoading(false)
      return response
    }
    catch (error) {
      console.log("Error GetProject", error)
      setLoading(false)
      return error;
    }

  }

  const changeBotType = e => {
    document.querySelectorAll(".list_bot_type .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setChannel(e.target.value);
  }
  const changeBot = async () => {

    // document.querySelector(".list_call_type .checkbox").forEach(element => element.checked = false);
    setChannel((prev) => prev === "voice" ? "chat" : "voice")
    
  }

  const changeAssistedSimulation = async (e)=>{
    setAssistedSimulation(prev => prev)
  }

  const changeCallType = e => {
    document.querySelectorAll(".list_call_type .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setCategory(e.target.value);
  }

  const changeTranscriptionEnable = e => {
    document.querySelectorAll(".list_transcription_enable .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setTranscription(e.target.value);
  }

  const changeUseDefaultSentiment = e => {
    document.querySelectorAll(".list_use_default_sentiment .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setUseDefaultSentiment(e.target.value);
  }

  const fetchVoice = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    let language = document.getElementById('language').value.replace('-US', '');

    try {
      const url = `${urlValue}/studio/project/voices/all`;
      
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'language': language
        },
      });

      if (rest.status === 200 && rest.data) {
        setVoices(rest.data.data)
        //setTimeout(()=>{document.querySelector("#voice").value = selectedProject.voice_id },700);
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
      return rest;;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/sub-campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const playAnswer = async ()=>{
    let voice = document.getElementById('voice').value;
    let rate = '0.00';
    let pitch = '0';
    let volume = '+100';
    let style = 'Friendly';
    
    const resToke = await axios.post(`https://eastus.api.cognitive.microsoft.com/sts/v1.0/issuetoken`, {}, {
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY
      }
    })
    let token = resToke.data;

    let speaker = `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" 
          xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="en-US">
        <voice name="${voice?.trim()?.replaceAll('_', '-')}">
            <prosody rate="${rate}" pitch="${pitch}" volume="${volume}">
                <mstts:express-as style="${style}">
                    This is a test voice
                </mstts:express-as>
            </prosody>
        </voice>
      </speak>`

      try {
        const res3 = await fetch('https://eastus.tts.speech.microsoft.com/cognitiveservices/v1', {
          method: 'POST',
          headers: {
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY,
            Authorization: `Bearer ${token}`,
            'cache-control': 'no-cache',
            'X-Microsoft-OutputFormat': 'riff-8khz-8bit-mono-alaw',
            'Content-Type': 'application/ssml+xml'
          },
          body: speaker
        });
        if (!res3.ok) {
          throw new Error('Fetch failed!');
        }
        const wavFile = await res3.blob();
        document.querySelector('#audioID').src = URL.createObjectURL(wavFile);
        document.querySelector('#audioID').play();
      } catch (error) {
        console.log(error)
      }

  }

  const stopAnswer = ()=>{

  }

  return (
    <>
      <form onSubmit={saveProject} className="settings-container pt-2 pb-5 " style={{ backgroundColor: '#F9F9F9', paddingRight: 17, borderRadius: 25 }}>
        <div className="scroll-internal ">
          <h2 className="pl-3" style={{ color: '#1C6FB0', fontSize: 16, marginBottom: 15, fontWeight: 'bold' }}>
            General Project Settings
          </h2>
          <div className="pl-3 d-flex flex-row">
            <div className="d-flex flex-column" style={{ width: '50%' }}>
              

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex flex-row align-items-center">
                  <span>Bot Type:</span>
                  <div className="ml-2 list_bot_type d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => changeBot()}
                      width={170}
                      state={channel === "chat" ? false : true}
                      height={30}
                      Yes='Voice Bot'
                      No='Chat Bot'
                    />
                  </div>
                </div>
              </div>

              <div className={`${channel==='chat' ? 'hidden': ''} inputs`} style={{ marginTop: 20 }}>
                <div className="input d-flex flex-row align-items-center">
                  <span>Interaction Type:</span>
                  <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setCategory((prev) => prev === "outbound" ? "inbound" : "outbound")}
                      width={170}
                      state={category === "outbound" ? false : true}
                      height={30}
                      Yes='Inbound'
                      No='Outbound'
                    />
                  </div>
                </div>
              </div>

              <div className={`${channel==='chat' ? 'hidden': ''} inputs`} style={{ marginTop: 20 }}>
                <div className="input d-flex flex-row align-items-center">
                  <span>Transcription Enable:</span>
                  <div className="list_transcription_enable ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setTranscription((prev) => prev === 0 ? 1 : 0)}
                      width={140}
                      state={transcription === 0 ? false : true}
                      height={30}
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex flex-row align-items-center">
                  <span>Default for Sentiment:</span>
                  <div className="list_use_default_sentiment ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setUseDefaultSentiment((prev) => prev === 0 ? 1 : 0)}
                      width={140}
                      state={useDefaultSentiment === 0 ? false : true}
                      height={30}
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex flex-column">
                  <span>Upload - Dialogflow file:</span>
                  <label className="custom-file mt-3">
                    <input
                      onChange={(e) => { setNlp_config(e.target.files[0]); setNlp_configName(e.target.files[0].name) }}
                      type="file"
                      accept=".json"
                    />
                    {nlp_configName}
                  </label>
                </div>
              </div>


              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span className="mr-2">Language:</span>
                    <div className="select" style={{ flexGrow: '2' }}>
                      <select id="language" className='ml-3 w-100 select-nesting' value={language} onChange={(e) => { setLanguage(e.target.value); }}
                        style={{ flexGrow: '2', fontSize: 14, backgroundPositionX: "98%" }}>
                        <option value="EN-US">English</option>
                        <option value="ES-CO">Spanish</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span className="mr-2">Campaign:</span>
                    <div className="select" style={{ flexGrow: '2' }}>
                      <select id="campaign" ref={campaingRef} className='ml-3 w-100 select-nesting'
                        style={{ flexGrow: '2', fontSize: 14, backgroundPositionX: "98%" }}>
                        {campaings.map((item, i) => (
                          <option value={item.id}  >{item.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span className="mr-2" style={{ whiteSpace: 'nowrap' }}>Sub-campaign:</span>
                    <div className="select" style={{ flexGrow: '2' }}>
                      <select id="subcampaign" ref={subCampaingRef} className='ml-3 w-100 select-nesting'
                        style={{ flexGrow: '2', fontSize: 14, backgroundPositionX: "98%" }}>
                        {subCampaings.map((item, i) => (
                          <option value={item.id}  >{item.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
 
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex items-center justify-content-between" style={{ height: "auto" }}>
                  <span style={{ marginRight: 5 }}>Resolution time:</span>
                  <input {...register('affectation_time', { required: false })}
                    ref={affectation_time_ref} defaultValue={selectedProject.affectation_time} id="affectation_time"
                    type="text" className="input-text  " />
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex items-center " style={{ height: "auto" }}>
                  <span style={{ marginRight: 5 }}>Percentage of affectation:</span>
                  <input {...register('percentage_affectation', { required: false })}
                    ref={percentage_affectation_ref} defaultValue={selectedProject.percentage_affectation} id="percentage_affectation"
                    type="text" className="input-text  " />
                </div>
              </div>

              
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex items-center justify-content-between" style={{ height: "auto" }}>
                  <span style={{ marginRight: 5 }}>Reply time:</span>
                  <input {...register('percentage_affectation', { required: false })}
                    ref={bot_respose_time_ref}   id="bot_respose_time"
                    type="text" className="input-text  " />
                </div>
              </div>
              {/* <InputNesting
                  ref={bot_respose_time_ref} id="bot_respose_time"
                  type="number"
                  containerClass="mr-2"
                  title="Reply time:"
                /> */}

              <div className="d-flex flex-column" style={{margin: '20px 0 0 0', borderTop: '1px solid rgb(172 172 172)', padding: '15px 0 0 0'}}>
                <div className='d-flex flex-row' style={{alignItems: 'center'}}>
                  <h2 className="" style={{ color: '#1C6FB0', fontSize: 16, marginBottom: 15, fontWeight: 'bold' }}>
                    TP Simulation
                  </h2>
                  <div style={{margin: '0 0 0 15px'}}>
                    <ButtonYesNo
                      onClick={() => setSimulationStatus((prev) => prev === 0 ? 1 : 0)}
                      width={150}
                      state={simulationStatus === 0 || simulationStatus === null ? false : true}
                      height={30}
                      Yes='Yes'
                      No='No'
                    />
                  </div>
                </div>
                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input d-flex flex-column" style={{ height: "auto" }}>
                    <span>URL TP Simulation:</span>
                    <input {...register('url_tp_simulation', { required: false })} disabled={!simulationStatus}
                      ref={url_simulationRef} defaultValue={selectedProject.url_tp_simulation} id="url_tp_simulation"
                      type="text" className="input-text mt-3" />
                  </div>
                </div>

                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input d-flex items-center " style={{ height: "auto" }}>
                    <span style={{ marginRight: 5 }}>Simulation Step number:</span>
                    <input {...register('num_simulation_steps', { required: false })} disabled={!simulationStatus}
                      ref={Simulation_Step_number_ref}   id="Simulation_Step_number_ref"
                      type="text" className="input-text  " />
                  </div>
                </div>

                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input d-flex flex-row align-items-center">
                    <span>Assisted Simulation:</span>
                    <div className="ml-2 list_bot_type d-flex flex-row align-items-center">
                      <ButtonYesNo
                        onClick={() => setAssistedSimulation((prev) => prev === 0 ? 1 : 0)}
                        width={150}
                        state={assistedSimulation === 0 ? false : true}
                        height={30}
                        Yes='Yes'
                        No='No'
                        disabled={!simulationStatus}
                      />
                    </div>
                  </div>
                </div>  
              </div>  

            </div>

            <div style={{ borderRight: '1px solid #bfbfbf', paddingLeft: 16, marginRight: 16 }} />

            <div className="d-flex flex-column pr-3" style={{ width: '35%' }}>

              <div className={`${channel==='chat' ? 'hidden': ''} flex flex-column `}  >
                <InputNesting
                  ref={minimunCallDurations} id="minimunCallDurations"
                  type="number"
                  containerClass={`${channel==='chat' ? 'hidden': ''} mr-2`}  
                  title="Minimun call durations (minutes):"
                />
                <InputNesting
                  containerClass="mr-2"
                  ref={maxUserResponseTime} id="maxUserResponseTime"
                  type="number"
                  title="Max user response time (seconds):"
                />

              </div>
              <div className="inputs">
                {/* <div className="input">
                  <div className='d-flex flex-row align-items-center w-100'>
                    <label htmlFor="use_hold">On-Hold Availability:</label>
                    <input
                      id="use_hold"
                      defaultChecked={hold}
                      onChange={(e) => { setHold(!hold); }}
                      type="checkbox"
                      style={{ marginLeft: 10, width: 'auto' }}
                    />
                  </div>
                </div>  */}
                <div className={`${channel==='chat' ? 'hidden': ''} input`} >
                  <div className='d-flex flex-col mt-5  w-100'>
                    <span style={{ marginRight: 5, marginBottom: "3%" }}>On-Hold Availability:</span>
                    <ButtonYesNo
                      onClick={() => setHold((prev) => !prev)}
                      width={140}
                      state={hold}
                      height={30}
                    />
                  </div>
                </div>
              </div>
              <div className={`${channel==='chat' ? 'hidden': ''} input`} style={{ marginTop: 25 }}>
                <div className="input">
                  <div className='d-flex flex-column'>
                    <span>Hold time (seconds):</span>
                    <input
                      ref={timeHoldRef}
                      className='mt-3 input-text'
                      disabled={!hold}
                      type="number"
                      defaultValue={timeHold}
                      id="hold_time"
                    />
                  </div>
                </div>
              </div>
              <div className={`${channel==='chat' ? 'hidden': ''} input`} style={{ marginTop: 25 }}>
                <div className="input">
                  <div className='d-flex flex-column'>
                    <span>Hold attempts:</span>
                    <div className="d-flex flex-row align-items-center mt-3">
                      <input style={{ maxWidth: 113 }}
                        ref={timeHoldAmountRef}
                        className='input-text'
                        disabled={!hold}
                        type="number"
                        defaultValue={amountTimeHold}
                        id="amount_time_hold"
                      />
                      <span className="ml-3" style={{ whiteSpace: 'nowrap' }}>per call</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-column">
                    <BoxInfo
                      id="botSentiment-tp"
                      titleClass='mr-0-4 color-label f-16  title-intent'
                      title="Bot Sentiment"
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={`<div>
                              The feeling of the style of the voice depends on the feeling marked by the thermometer in the call<br />
                              </div>`}
                    />
                    <div className="select" style={{ maxWidth: 183, marginTop: 5 }}>
                      <select id="bot_sentiment" onChange={saveBotSentimentConfig} ref={sentimentBotRef} className="w-100 select-nesting" style={{ backgroundPositionX: "98%" }}>
                        <option value="1" selected={selectedProject.bot_sentiment !== 0 ? 'selected' : ''}>ON</option>
                        <option value="0" selected={selectedProject.bot_sentiment === 0 ? 'selected' : ''}>OFF</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-column">
                    <BoxInfo
                      id="ModelSentiment-tp"
                      titleClass='mr-0-4 color-label f-16  title-intent'
                      title="Model Sentiment"
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={`<div>
                              Select the polarity model with which the thermometer will move <br />
                              </div>`}
                    />
                    <div className="select" style={{ maxWidth: 183, marginTop: 5, }}>
                      <select id="model_sentiment" className="w-100 select-nesting" style={{ backgroundPositionX: "98%" }}>
                        <option value="Phrase">Phrase</option>
                        <option value="Voice">Voice</option>
                        <option value="Answer">Answer</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input">
                  <div className='d-flex flex-row align-items-center w-100'>
                    <span style={{ minWidth: 138 }}>Use random voices?</span>
                    <input
                      id="random_voice"
                      style={{ marginLeft: 10, width: 'auto' }}
                      defaultChecked={selectedProject.random_voice}
                      onChange={(e) => { setRadomVoice(!radomVoice); }}
                      type="checkbox"
                    />
                  </div>
                </div>
              </div>               */}

              <div className={`${channel==='chat' ? 'hidden': ''} input`} style={{ marginTop: 25 }}>
                <div className="input">
                  <div className='d-flex flex-col  w-100'>
                    <span style={{ marginRight: 5, marginBottom: "3%" }}>Use random voices?</span>
                    <ButtonYesNo
                      onClick={() => setRadomVoice((prev) => !prev)}
                      width={140}
                      state={radomVoice}
                      height={30}
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-column">
                    <span>Select voice:</span>
                    <div className="select" style={{ maxWidth: 183, marginTop: 5 }}>
                      <select className='w-100 select-nesting' style={{ flexGrow: '2', backgroundPositionX: "98%" }} id="voice">
                        {voices.map((item, index) => (
                          <option key={index} value={item.id}>{item.voice}</option>
                        ))}
                      </select>
                    </div>
                    {/*
                    <div className='d-flex align-items-center mt-5'>
                        <a href="#" id='play_audio' onClick={() => { playAnswer() }}>
                          <img src={PlayIcon} alt="" width={12} />
                        </a>
                        <a href="#" id='pause_audio' onClick={() => { stopAnswer() }} style={{marginLeft: 10}}>
                          <img src={PauseIcon} alt="" width={12} />
                        </a>
                    </div>
                    <div style={{marginLeft: 10}}>
                      <audio id="audioID" controls>
                        <source type="audio/mpeg" />
                      </audio>
                    </div>
                    */}
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className='cont-buttons mt-5 w-100'>
            <div className="buttons d-flex flex-row justify-end pr-3">
              <button className="create btn-primary btn-bottom btn-bottom-create" type="submit" style={{ backgroundColor: "#0087FF" }}>
                Save
              </button>
            </div>
          </div>
        </div>
        {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
      </form>
    </>
  )
}
